import {
    faCalendar,
    faCheckSquare,
    faDotCircle,
    faFont,
    faHashtag,
    faLink,
    faList,
    faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { QuestionType } from "../schemas/types";

export const availableQuestionTypes: QuestionType[] = [
    {
        label: "Texto curto",
        value: "short-text",
        icon: faFont,
    },
    {
        label: "Texto longo",
        value: "long-text",
        icon: faFont,
    },
    {
        label: "Lista suspensa",
        value: "select",
        icon: faList,
    },
    {
        label: "Múltipla escolha",
        value: "radio-group",
        icon: faDotCircle,
    },
    {
        label: "Caixas de Seleção",
        value: "checkbox-group",
        icon: faCheckSquare,
    },
    {
        label: "Data",
        value: "date",
        icon: faCalendar,
    },
    {
        label: "Número",
        value: "number",
        icon: faHashtag,
    },
    {
        label: "Upload de arquivo",
        value: "upload",
        icon: faUpload,
    },
    {
        label: "Link",
        value: "url",
        icon: faLink,
    },
];